export const CBR_ACC_SLOTS_LOADING_STATUS = {
  INACTIVE: 'inactive',
  IN_PROGRESS: 'in_progress',
  FAILED: 'failed'
}

export const CBR_ACC_SLOTS_LOADING_STATUS_COLOR = {
  INACTIVE: '#58d08d',
  IN_PROGRESS: '#fb8c00',
  FAILED: '#ff5252'
}